import { createStore } from 'vuex';
import caseNoteOptions from './caseNoteOptions';

const store = createStore({
  state() {
    return {
      msalConfig: {
        auth: {
          clientId: '7c09f2d8-de7a-458c-b070-fa0befacd4bd',
          authority:
            'https://login.microsoftonline.com/b58faf5f-a68b-4398-9ea3-c3b399670362',
        },
        cache: {
          cacheLocation: 'localStorage',
        },
      },
      accessToken: '',
    };
  },
  mutations: {
    setAccessToken(state, token) {
      state.accessToken = token;
    },
  },
  modules: {
    caseNoteOptions,
  },
});

export default store;
